
import { CommonModule } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { I18nModule, WindowRef } from '@spartacus/core';
import { GenDocument } from 'src/app/generac/models/document.model';

@Component({
    selector: 'gen-document-list-item',
    templateUrl: './document-list-item.component.html',
    imports: [ CommonModule, I18nModule]
})

export class GenDocumentListItemComponent {
  @Input() document: GenDocument;

  @HostListener('window:resize')
  onResize() {
    this.isMobileView = this.winRef?.nativeWindow.innerWidth < 768;
  }

  isMobileView: boolean;

  constructor(
    protected winRef: WindowRef,
  ) {
    this.isMobileView = this.winRef?.nativeWindow.innerWidth < 768;
  }

  viewDocument(doc: GenDocument): void {
    window.open(doc.fileUrl, '_blank');
  }
}
